module.exports = __webpack_public_path__ + "img/close-black.9b47b68a.svg";